// Build the PDF filename used for weekly newsletter downloads
export const buildPdfFileName = (year, week) => {
    return `alphalinerweekly-${year}-${week}.pdf`;
};

// Build the full API URL for a weekly PDF download
export const buildPdfFileUrl = (fileName, apiRootUrl) => {
    return `${apiRootUrl}/v1/data/${fileName}`;
};
